import { render, staticRenderFns } from "./GenericExpandableList.vue?vue&type=template&id=470444cc&scoped=true"
import script from "./GenericExpandableList.vue?vue&type=script&lang=js"
export * from "./GenericExpandableList.vue?vue&type=script&lang=js"
import style0 from "./GenericExpandableList.vue?vue&type=style&index=0&id=470444cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470444cc",
  null
  
)

export default component.exports